module.exports = "https://cdn.hellotech.com/client-assets/consult-modal-img-mobile_09000f0ff26dd89281ad03e8f59f4475.png";